import React from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import WithProcessError from 'hocs/WithProcessError';
import PropTypes from 'prop-types';

// import IconButton from 'components/IconButton/IconButton';
import { yookassaDefaults } from './TerminalTypes/constants';
import Tinkoff from './TerminalTypes/Tinkoff';
import Yookassa from './TerminalTypes/Yookassa/Yookassa';
import { tinkoffDefaults } from './constants';

// import Delete24 from 'icons/Delete24';
import useApi from 'utils/api';
import { useAuth } from 'utils/auth';

const TerminalSettingsLayout = (serviceId) => {
    switch (serviceId) {
        case 1:
            return Tinkoff;
        case 2:
            return Yookassa;
        default:
            return Tinkoff;
    }
};

const getDefaultTerminalSettings = (serviceId) => {
    switch (serviceId) {
        case 2:
            return yookassaDefaults;
        case 1:
            return tinkoffDefaults;
        default:
            return tinkoffDefaults;
    }
};

function TerminalSettings(props) {
    const { onClose, terminalId, serviceId } = props;

    const api = useApi();
    const auth = useAuth();
    const queryClient = useQueryClient();

    const companyId = auth?.company.id;

    const { isLoading, data } = useQuery({
        queryKey: ['terminal-settings', companyId, terminalId],
        refetchOnWindowFocus: false,
        retry: 0,
        queryFn: () => {
            if (!terminalId) {
                return getDefaultTerminalSettings(serviceId);
            }

            return api.getTerminal(companyId, terminalId);
        },
        onError: (error) => {
            props.processError('Не удалось загрузить терминал.', error);
        },
    });
    const terminalSettings = data ?? getDefaultTerminalSettings(serviceId);

    const createTerminalMutation = useMutation({
        mutationFn: (settings) => api.createTerminal(companyId, serviceId, settings, settings.isYookassa),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['payment-services', companyId] });
            queryClient.setQueryData(['terminal-settings', companyId, terminalId], data);
        },
        onError: (error) => {
            props.processError('Не удалось создать терминал', error);
        },
    });

    const updateTerminalMutation = useMutation({
        mutationFn: (settings) => api.updateTerminal(companyId, terminalId, settings),
        onSuccess: (data) => {
            queryClient.setQueryData(['terminal-settings', companyId, terminalId], data);
        },
        onError: (error) => {
            props.processError('Не удалось сохранить терминал.', error);
        },
    });

    // const deleteTerminalMutation = useMutation({
    //     mutationFn: () => api.deleteTerminal(companyId, terminalId),
    //     onSuccess: () => {
    //         onClose();
    //     },
    // });

    function onBackClick() {
        if (typeof onClose === 'function') onClose();
    }

    function saveTerminal(terminalSettings) {
        if (terminalId === null) {
            createTerminalMutation.mutate(terminalSettings);
        } else {
            updateTerminalMutation.mutate(terminalSettings);
        }
    }

    const showButtonLoader = isLoading || updateTerminalMutation.isLoading || createTerminalMutation.isLoading;

    const SettingsLayout = TerminalSettingsLayout(serviceId);

    return (
        <>
            <SettingsLayout
                terminalSettings={terminalSettings}
                onTerminalSave={saveTerminal}
                onCancel={onBackClick}
                isLoading={showButtonLoader}
            />
            {/* <IconButton icon={<Delete24 />} text="Удолить терминал" onClick={() => deleteTerminalMutation.mutate()} /> */}
        </>
    );
}

TerminalSettings.propTypes = {
    terminalId: PropTypes.number,
    serviceId: PropTypes.number,
    onClose: PropTypes.func.isRequired,
    ...WithProcessError.props,
};

export default WithProcessError(TerminalSettings);
